<template>
    <div class="chart">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path d="M72,104a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,104Zm8,40h96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16ZM232,56V208a8,8,0,0,1-11.58,7.15L192,200.94l-28.42,14.21a8,8,0,0,1-7.16,0L128,200.94,99.58,215.15a8,8,0,0,1-7.16,0L64,200.94,35.58,215.15A8,8,0,0,1,24,208V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V195.06l20.42-10.22a8,8,0,0,1,7.16,0L96,199.06l28.42-14.22a8,8,0,0,1,7.16,0L160,199.06l28.42-14.22a8,8,0,0,1,7.16,0L216,195.06Z"></path></svg>
            {{ titulo }}
        </span>
        <ChartLineBase :chart-data="chartData" />
    </div>
</template>

<script>
import ChartLineBase from "@/components/chart/ChartLineBase";

export default {
    components: {
        ChartLineBase
    },

    props: ['titulo', 'rotulos', 'dados'],

    data() {
        return {
            chartData: {},
            rotulosAux: this.rotulos,
            dadosAux: this.dados
        }
    },

    methods: {
        fillData() {
            const arrayRotulos = this.rotulosAux.split(',') 
            const arrayDados   = this.dadosAux.split(',')    
            this.chartData = {
                labels: arrayRotulos,
                datasets: [
                    {
                        backgroundColor: "#98ddde",
                        borderColor: "#030c0c",
                        data: arrayDados,  
                        label: "Quantidade"
                    }   
                ]
            };            
        }
    },

    mounted() {
        this.rotulosAux = this.rotulosAux.replace(/['"]+/g, '')
        this.fillData();
    },

    created() {
        this.rotulosAux = this.rotulos
        this.dadosAux = this.dados
	}    
};
</script>